// Definizione tecniche ATC per Taekwondo Olimpico
const ATC_TECHNIQUES = [
  { id: 'Bn',    name: 'Bandal chagi',       type: 'circolare',  targets: ['corpo', 'testa'] },
  { id: 'Dl',    name: 'Dollyo chagi',        type: 'circolare',  targets: ['testa'] },
  { id: 'Nr',    name: 'Neryo chagi',         type: 'lineare',    targets: ['testa'] },
  { id: 'Pk',    name: 'Push Kick',           type: 'lineare',    targets: ['corpo', 'testa'] },
  { id: 'Dw',    name: 'Dwit chagi',          type: 'rotazione',  targets: ['corpo', 'testa'] },
  { id: 'Md',    name: 'Momdollyo chagi',     type: 'rotazione',  targets: ['corpo', 'testa'] },
  { id: 'Pugno', name: 'Pugno (momtong)',     type: 'lineare',    targets: ['corpo'] },
  { id: '2Bn',   name: 'Doppio bandal',       type: 'combinato',  targets: ['corpo', 'testa'] },
  { id: '360Bn', name: '360 Bandal chagi',    type: 'rotazione',  targets: ['corpo', 'testa'] },
  { id: '360Dl', name: '360 Dollyo chagi',    type: 'rotazione',  targets: ['corpo', 'testa'] },
  { id: 'Gr',    name: 'Gerogi',              type: 'lineare',    targets: ['corpo'] },
  { id: 'Clsh',  name: 'Clash',              type: 'parata',     targets: [] },
  { id: 'custom',name: 'Custom',             type: 'custom',     targets: ['corpo', 'testa'] },
];

export default ATC_TECHNIQUES;

export const getTechniqueById = (id) => ATC_TECHNIQUES.find(t => t.id === id);

export const isRotationTechnique = (id) => {
  const t = getTechniqueById(id);
  return t?.type === 'rotazione';
};
